import { getInvoiceListbyInvoiceNum } from "services/procurement/procurementAPIs";

import { setShowInvoiceSummaryDialogue } from "../redux/actions/generalActions";
import {
    setInvoiceListIsLoading,
    setInvoiceSearchNumber,
} from "../redux/actions/invoiceListActions";

export const openInvoiceSummaryDialogue = (invoiceNumber, dispatch) => {
    /*
    Arguments
    ---------
    invoiceNumber : str
    dispatch : func
    */
    // Open the form, request required data
    // set number
    dispatch(setInvoiceSearchNumber(invoiceNumber));
    dispatch(setInvoiceListIsLoading(true));
    getInvoiceListbyInvoiceNum(invoiceNumber, dispatch);
    dispatch(setShowInvoiceSummaryDialogue(true));
};

export const closeInvoiceSummaryDialogue = (dispatch) => {
    /*
    Arguments
    ---------
    invoiceNumber : str
dispatch : func
    */
    // Open the form, request required data
    // set number
    dispatch(setShowInvoiceSummaryDialogue(false));
};
